module.exports = __webpack_public_path__ + "media/images/new/icons/pinterest-fe3cbc51fad8618b6b963decda194121.png";